import {Component, OnInit} from '@angular/core';
import {ModelCode} from '../../../models/promotions/model-codes.model';
import {HttpService} from '../../../services/http.service';
import {AdminContractType} from '../../../models/config/admin-contract-type.model';
import {AgeFactor} from '../../../models/config/age-factor.model';
import {MileageFactor} from '../../../models/config/mileage-factor.model';
import {SweetUtil} from '../../commons/sweet/sweet-util-service';
import {ModelCodeFilter} from '../../../models/config/model-code-filter.model';
import {ModelCodeList} from '../../../models/config/model-code-list.model';
import {ToggleService} from '../../../toggle/toggle.service';
import {AuthService} from '../../../auth/auth.service';
import {FeatureToggle} from '../../../toggle/feature-toggle';
import {Market} from '../../../models/dealers/market.enum';
import {ModelGroup} from '../../../model-group/model-group.model';
import {ModelGroupService} from '../../../model-group/model-group.service';

@Component({
  selector: 'app-warranty-config',
  templateUrl: './warranty-config.component.html',
  styleUrls: ['./warranty-config.component.scss']
})
export class WarrantyConfigComponent implements OnInit {
  showModelGroups = false;
  modelGroupActive = false;
  showContractTypes = true;
  showModelFactors = false;
  showAgeFactors = false;
  showConfigurableDate = false;
  showAgeAndMileage = false;
  selectedYear: number = this.getCurrentYear();
  availableYears: number[];

  ageFactors: AgeFactor[] = [];
  contractTypes: AdminContractType [] = [];
  modelGroups: Array<ModelGroup> = [];
  fuels = ['Benzine', 'Diesel'];
  selectedContractType: AdminContractType = null;
  selectedModelGroup: ModelGroup = null;
  filter: ModelCodeFilter = new ModelCodeFilter();
  modelCodeList: ModelCodeList;
  modelCodeYear: number = this.getCurrentYear();
  showModels = false;
  modelsActive = false;
  modelFactorsActive = false;
  ageFactorsActive = false;
  ageMileageActive = false;
  groupPricingActive = false;
  showGroupPricing = false;
  bestTypes = new Set<string>();

  constructor(private http: HttpService, private sweetUtil: SweetUtil, private toggleService: ToggleService,
              private authService: AuthService, private modelGroupService: ModelGroupService) {
  }

  ngOnInit(): void {
    this.modelFactorsActive = this.authService.market() === Market.BE;
    this.ageFactorsActive = this.authService.market() === Market.BE;
    this.getAgeAndMileageToggle();
    this.getModelsToggle();
    this.getAllAvailableYears();
    this.getGroupPricing();
    this.fetchModelCodes();
    this.fetchAgeFactors();
    this.fetchContractTypes();
    if (this.authService.market() === Market.NL) {
      this.getAllModelGroups();
      this.toggleService.active(FeatureToggle.MODEL_GROUP).subscribe((active) => {
        this.modelGroupActive = active;
      });
    }
  }

  addBestTypes(){
    ['W', 'U', 'R', 'S', 'T', 'M'].forEach ((item) => {
      this.bestTypes.add(item);
    });

    this.contractTypes.forEach((item) => {
      this.bestTypes.add(item.bestType);
    });
  }
  getAgeAndMileageToggle() {
    if (this.authService.market() === Market.NL) {
      this.toggleService.active(FeatureToggle.AGE_AND_MILEAGE).subscribe((active) => {
        this.ageMileageActive = active;
      });
    }
  }

  getModelsToggle() {
    if (this.authService.market() === Market.NL) {
      this.toggleService.active(FeatureToggle.MODELS).subscribe((active) => {
        this.modelsActive = active;
      });
    }
  }

  getGroupPricing() {
    if (this.authService.market() === Market.NL) {
      this.toggleService.active(FeatureToggle.PRICING_GROUP).subscribe((active) => {
        this.groupPricingActive = active;
      });
    }
  }

  getAllModelGroups() {
    this.modelGroupService.findAll().subscribe((modelGroups: ModelGroup[]) => {
      this.modelGroups = modelGroups;
    });
  }

  getAllAvailableYears() {
    this.http.getAvailableYears().subscribe(res => {
      this.availableYears = Object.assign([], res);
    });
  }

  fetchModelCodes() {
    this.http.fetchAdminModelCodes(this.filter).subscribe((res) => {
      this.modelCodeList = Object.assign(new ModelCodeList(), res);
    });
  }

  addNewModelCode() {
    this.modelCodeList.dataList.unshift(new ModelCode());
  }

  removeModelCode(model: ModelCode) {
    this.modelCodeList.dataList.splice(this.modelCodeList.dataList.indexOf(model), 1);
  }

  updateModelCode(model: ModelCode) {
    if (!model.id) {
      model.validFrom = this.modelCodeYear + '-01-01';
      model.validTo = this.modelCodeYear + '-12-31';
    }

    this.http.saveModelCode(model).subscribe(() => {
      this.fetchModelCodes();
    }, error => {
      if (error.status === 422) {
        this.sweetUtil.showError('warranty-config-duplicate').then();
      }
      if (error.status === 400) {
        this.sweetUtil.showError('Incomplete Model Code data. Please ensure you have correctly inputted all fields.').then();
      }
      if (error.status === 409) {
        this.sweetUtil.showError('warranty-config-duplicate').then();
      }
    });
  }

  fetchAgeFactors() {
    if (!this.ageFactorsActive){
      return;
    }
    this.http.fetchAdminAgeFactors(this.selectedYear).subscribe((res) => {
      this.ageFactors = Object.assign([], res);
    });
  }

  updateAgeModel(model: AgeFactor) {
    if (model.ageFrom < model.ageTo) {
      this.http.saveAgeModel(model).subscribe(() => {
        this.fetchAgeFactors();
      }, error => {
        if (error.status === 422) {
          this.sweetUtil.showError('Cannot save Age Factor. Day range conflicts with another record.').then();
        }
      });
    } else {
      this.sweetUtil.showError('Age FROM must be smaller than Age TO').then();
    }
  }

  fetchContractTypes() {
    let temp: AdminContractType = null;
    if (this.selectedContractType) {
      temp = Object.assign(new AdminContractType(), this.selectedContractType);
    }
    this.http.fetchAdminContractTypes().subscribe((res) => {
      Object.assign(this.contractTypes, res);
      this.addBestTypes();
      if (temp) {
        this.selectedContractType = this.contractTypes.find(c => c.contractCode === temp.contractCode);
      }
    });

  }

  updateContractType(c: AdminContractType) {
    this.http.saveAdminContractType(c).subscribe(() => {
      this.fetchContractTypes();
      SweetUtil.showSuccess('Updated Contract').then();
    });
  }

  updateMileageFactor(m: MileageFactor, contractCode: string) {
    if (contractCode && this.isMileageFactorValid(m)) {
      this.http.saveMileageFactor(m, contractCode).subscribe(() => {
        this.fetchContractTypes();
        SweetUtil.showSuccess('Updated Contract').then();
      }, error => {
        if (error.status === 422) {
          this.sweetUtil.showError('Cannot save Mileage Factor. Date range conflicts with another record under this contract code.').then();
        }
        if (error.status === 400) {
          this.sweetUtil.showError('Incomplete Mileage Factor data. Please ensure you have correctly inputted all fields.').then();
        }
      });
    }
  }

  orderBy(field: string) {
    if (this.filter.orderBy === field) {
      if (this.filter.order === 'ASC') {
        this.filter.order = 'DESC';
      } else {
        this.filter.order = 'ASC';
      }
    }
    this.filter.orderBy = field;
    this.fetchModelCodes();
  }

  showDirectionImage(): string {
    if (this.filter.order === 'ASC') {
      return 'assets/images/icon-sort-up.png';
    } else {
      return 'assets/images/icon-sort-down.png';
    }
  }

  switchAllOff() {
    this.showModelGroups = false;
    this.showModelFactors = false;
    this.showContractTypes = false;
    this.showAgeFactors = false;
    this.showConfigurableDate = false;
    this.showModels = false;
    this.showAgeAndMileage = false;
    this.showGroupPricing = false;
    this.filter.page = 0;
  }

  switchModelFactors() {
    this.switchAllOff();
    this.showModelFactors = true;
  }

  switchToConfigureDates() {
    this.switchAllOff();
    this.showConfigurableDate = true;
  }

  switchAgeFactors() {
    this.switchAllOff();
    this.showAgeFactors = true;
  }

  switchContractTypes() {
    this.switchAllOff();
    this.showContractTypes = true;
  }

  switchToModelGroups(): void {
    this.switchAllOff();
    this.showModelGroups = true;
  }

  switchModels() {
    this.switchAllOff();
    this.showModels = true;
  }

  switchAgeMileage() {
    this.switchAllOff();
    this.showAgeAndMileage = true;
  }

  switchGroupPricing() {
    this.switchAllOff();
    this.showGroupPricing = true;
  }

  isMileageFactorValid(m: MileageFactor) {
    if (m.validFrom === null || m.validTo === null) {
      return false;
    }
    if (m.baseRate === null || m.averageKms === null || m.averageKms === 0) {
      return false;
    }
    if (m.deviationLowerLimit === null || m.deviationUpperLimit === null) {
      return false;
    }
    if (m.upperLimitFactor === null || m.lowerLimitFactor === null) {
      return false;
    }
    return true;
  }

  isContractTypeValid(m: AdminContractType) {
    return true;
  }

  addNewMileageFactor(c: AdminContractType) {
    c.mileageFactors.push(new MileageFactor());
  }

  removeMileageFactor(m: MileageFactor, c: AdminContractType) {
    if (m.id) {
      SweetUtil.getConfirm('Delete', 'Are you sure you want to delete this factor?').then((res) => {
        if (res.value) {
          this.http.deleteMileageFactor(m).subscribe(() => {
            this.fetchContractTypes();
          });
        }
      });
    } else {
      const i = c.mileageFactors.indexOf(m);
      c.mileageFactors.splice(i, 1);
    }
  }

  getCurrentYear() {
    return new Date().getFullYear();
  }

  changePage(count: number) {
    this.filter.page += count;
    this.fetchModelCodes();
  }

  selectYear(num: number) {
    this.selectedYear = num;
    this.filter.validFrom = num + '-01-01';
    this.filter.validTo = num + '-12-31';
    this.filter.page = 0;
    this.fetchModelCodes();
  }

  search() {
    this.fetchModelCodes();
  }

  clear() {
    this.filter = new ModelCodeFilter();
    this.fetchModelCodes();
  }

  selectAgeYear(num: number) {
    this.selectedYear = num;
    this.fetchAgeFactors();
  }

}
